// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PpK2","clinicsSelect":"styles_clinicsSelect__2qBVg"};